import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-seas-blue text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company info */}
          <div>
            <img src="/images.png" alt="Seas Heating and AC" className="h-10 w-auto mb-4 opacity-90" />
            <h3 className="text-lg font-bold mb-4">Seas Heating and AC</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Trusted HVAC services in Las Vegas since day one. Family-owned, locally operated. 
              Your comfort is our priority.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-seas-gold transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-seas-gold transition-colors">Services</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-seas-gold transition-colors">About Us</Link></li>
              <li><Link to="/testimonials" className="text-gray-300 hover:text-seas-gold transition-colors">Testimonials</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-seas-gold transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a href="tel:+17023449797" className="hover:text-seas-gold transition-colors">(702) 344-9797</a>
              </li>
              <li>
                <a href="mailto:info@seasheatingandac.com" className="hover:text-seas-gold transition-colors">
                  info@seasheatingandac.com
                </a>
              </li>
              <li className="text-sm">Las Vegas, NV</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-600 mt-8 pt-8 flex flex-col sm:flex-row justify-end items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} Seas Heating and AC. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
